import * as React from 'react'

import {
  type LandingInstructor,
  NON_FSDS_CONTENT,
  NON_FSDS_PARTNERS,
  NON_FSDS_PROJECTS,
  NON_FSDS_VI_FEATURES,
} from '@/components/homepage/non-fsds-landing-content'
import NonFsdsCorporateCustomerSection from '@/components/homepage/non-fsds-sections/non-fsds-corporate-customer-section'
import NonFsdsFaqSection from '@/components/homepage/non-fsds-sections/non-fsds-faq-section'
import NonFsdsFeaturePoweredSection from '@/components/homepage/non-fsds-sections/non-fsds-feature-powered-section'
import NonFsdsFeatureSection from '@/components/homepage/non-fsds-sections/non-fsds-feature-section'
import NonFsdsFeedbackSection from '@/components/homepage/non-fsds-sections/non-fsds-feedback-section'
import NonFsdsHeroSection from '@/components/homepage/non-fsds-sections/non-fsds-hero-section'
import NonFsdsLecturersSection from '@/components/homepage/non-fsds-sections/non-fsds-lecturers-section'
import NonFsdsMoneyBackGuaranteeSection from '@/components/homepage/non-fsds-sections/non-fsds-money-back-guarantee-section'
import NonFsdsProjectSection from '@/components/homepage/non-fsds-sections/non-fsds-project-section'
import NonFsdsStatsSection from '@/components/homepage/non-fsds-sections/non-fsds-stats-section'

interface NonFsdsLandingPageProps {
  lang: string
  isCourseEnrolled: boolean
  instructorsList: LandingInstructor[]
}

export default function NonFsdsLandingPage({ lang, isCourseEnrolled, instructorsList }: NonFsdsLandingPageProps) {
  const copy = lang === 'en' ? NON_FSDS_CONTENT.en : NON_FSDS_CONTENT.vi
  const isEnglish = lang === 'en'
  const visibleInstructors = instructorsList.filter(instructor => instructor?.status === 'active')

  return (
    <main data-testid="non-fsds-landing-page" data-legacy-fallback="true" className="bg-background text-foreground">
      <NonFsdsHeroSection
        title={copy.heroTitle}
        description={copy.heroDescription}
        ctaStart={copy.ctaStart}
        ctaContinue={copy.ctaContinue}
        ctaExplore={copy.ctaExplore}
        ctaStartUrl={copy.ctaStartUrl}
        ctaContinueUrl={copy.ctaContinueUrl}
        ctaExploreUrl={copy.ctaExploreUrl}
        trustItems={copy.trustItems}
        isCourseEnrolled={isCourseEnrolled}
        isEnglish={isEnglish}
      />

      <NonFsdsStatsSection stats={copy.stats} />

      <NonFsdsCorporateCustomerSection title={copy.partnersTitle} partners={NON_FSDS_PARTNERS} />

      <NonFsdsMoneyBackGuaranteeSection title={copy.guaranteeTitle} description={copy.guaranteeDescription} />

      <NonFsdsProjectSection
        title={copy.projectTitle}
        description={copy.projectDescription}
        projects={NON_FSDS_PROJECTS}
      />

      <NonFsdsFeatureSection features={NON_FSDS_VI_FEATURES} />
      <NonFsdsFeaturePoweredSection
        title={copy.featurePoweredTitle}
        description={copy.featurePoweredDescription}
        items={copy.featurePoweredItems}
      />

      <NonFsdsLecturersSection
        title={copy.expertInstructorsTitle}
        instructors={visibleInstructors}
        isEnglish={isEnglish}
      />

      <NonFsdsFeedbackSection title={copy.feedbackTitle} quotes={copy.feedbackQuotes} isEnglish={isEnglish} />

      <NonFsdsFaqSection title={copy.faqTitle} faqs={copy.faqs} />
    </main>
  )
}
